<app-table-card-layout
    #cardLayout
    title="Transactions information"
    [isLoading]="isDCPolicyLoaded"
    [failed]="dcPolicyFailed"
    [hasData]="allTransactions.length > 0"
    [noDataMessage]="globalMessages.noDataAvailabelMsg"
    [errorMessage]="globalMessages.serviceMsgError"
    (retry)="retryDCPolicy()"
>
    @if (allTransactions.length > 0) {
        <div [class.d-none]="isDCPolicyLoaded" class="d-flex flex-column psic-gap-6">
            @if (!cardLayout.isCompact()) {
                <!-- Standard table view -->
                <div class="table-container" [class.table-container--collapsed]="!showAll && allTransactions.length > 5">
                    <table class="transactions-table">
                        <thead>
                            <tr class="disclaimer-bold">
                                <th class="psic-py-2 psic-px-4">Reason Code</th>
                                <th class="psic-py-2 psic-px-4">Description</th>
                                <th class="psic-py-2 psic-px-4">Next Step</th>
                                <th class="psic-py-2 psic-px-4">Next Action Date</th>
                                <th class="psic-py-2 psic-px-4">Logged Off</th>
                                <th class="psic-py-2 psic-px-4">Logged Off Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (transaction of allTransactions; track transaction) {
                            <tr class="disclaimer">
                                <td class="psic-p-4">
                                    <div class="reason-code disclaimer psic-gap-1">
                                        <div>
                                            <strong>{{ transaction.reasonCode }}</strong>
                                        </div>
                                    </div>
                                </td>
                                <td class="psic-p-4">
                                    <div class="" [innerHTML]="transaction.description"></div>
                                </td>
                                <td class="psic-p-4">
                                    <div class="cell-content" [innerHTML]="transaction.nextStep"></div>
                                </td>
                                <td class="psic-p-4">
                                    <div class="cell-content">{{ transaction.nextActionDate }}</div>
                                </td>
                                <td class="d-flex align-items-center justify-content-center psic-p-4">
                                    <span
                                        class="badge disclaimer-bold psic-py-1 psic-px-2"
                                        [class.yes]="transaction.loggedOff"
                                        [class.no]="!transaction.loggedOff"
                                    >
                                        {{ transaction.loggedOff ? 'Yes' : 'No' }}
                                    </span>
                                </td>
                                <td class="psic-p-4">
                                    <div class="cell-content">{{ getLoggedOffDate(transaction) }}</div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            } @else {
                <!-- Compact 2-column key-value view -->
                <div class="compact-list d-flex flex-column psic-gap-6" [class.compact-list--collapsed]="!showAll && allTransactions.length > 5">
                    @for (transaction of allTransactions; track transaction) {
                    <div class="compact-card">
                        <table class="compact-table">
                            <tbody class="d-flex flex-column psic-gap-3 psic-py-3">
                                <tr>
                                    <td class="compact-label disclaimer-bold">Reason Code</td>
                                    <td class="compact-value disclaimer">
                                        <strong>{{ transaction.reasonCode }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Description</td>
                                    <td class="compact-value disclaimer" [innerHTML]="transaction.description"></td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Next Step</td>
                                    <td class="compact-value disclaimer" [innerHTML]="transaction.nextStep"></td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Next Action Date</td>
                                    <td class="compact-value disclaimer">{{ transaction.nextActionDate }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Logged Off</td>
                                    <td class="compact-value">
                                        <span
                                            class="badge disclaimer-bold psic-py-1 psic-px-2"
                                            [class.yes]="transaction.loggedOff"
                                            [class.no]="!transaction.loggedOff"
                                        >
                                            {{ transaction.loggedOff ? 'Yes' : 'No' }}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Logged Off Date</td>
                                    <td class="compact-value disclaimer">{{ getLoggedOffDate(transaction) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    }
                </div>
            }

            @if (!showAll && allTransactions.length > 5) {
                <div class="d-flex flex-row justify-content-center align-items-center w-100">
                    <lib-button
                        [buttonType]="'borderless'"
                        [buttonSize]="'medium'"
                        [buttonText]="'Show more'"
                        [libIcon]="'chevron-down'"
                        (callback)="loadMore()"
                    ></lib-button>
                </div>
            } @else if (showAll && allTransactions.length > 5) {
                <div class="d-flex flex-row justify-content-center align-items-center w-100">
                    <lib-button
                        [buttonType]="'borderless'"
                        [buttonSize]="'medium'"
                        [buttonText]="'Show less'"
                        [libIcon]="'chevron-up'"
                        (callback)="showLess()"
                    ></lib-button>
                </div>
            }
        </div> 
    }
</app-table-card-layout>
